import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const StyledInput = styled.input`
  width: 100%;
  height: 48px;
  padding: 0.5rem;
  font-size: 1rem;
  font-family: inherit;
  color: #232323;
  border: 1px solid #d7d3d0;
  border-radius: 0.625rem;
  background: #ffffff;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: var(--rg-primary-color, #1249a1);
  }

  &::placeholder {
    color: #57534e;
    font-size: 0.9rem;
  }

  &:disabled {
    background: #f0f0f0;
    cursor: not-allowed;
  }
`;

const StyledErrorWrapper = styled.div<{ $visible: boolean }>`
  display: grid;
  grid-template-rows: ${({ $visible }) => ($visible ? '1fr' : '0fr')};
  transition: grid-template-rows 200ms ease;
`;

const StyledErrorInner = styled.span<{ $visible: boolean }>`
  overflow: hidden;
  font-size: 0.8125rem;
  color: #d32f2f;
  padding-left: 0.25rem;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  padding-bottom: ${({ $visible }) => ($visible ? '0.5rem' : '0')};
  transition:
    opacity 200ms ease,
    padding-bottom 200ms ease;
`;

type Props = {
  name: string;
  type?: string;
  placeholder?: string;
  value: string;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
};

export function FormField({
  name,
  type = 'text',
  placeholder,
  value,
  error,
  touched,
  disabled,
  onChange,
  onBlur,
}: Readonly<Props>) {
  const showError = touched && error;

  return (
    <StyledWrapper>
      <StyledInput
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        aria-invalid={!!showError}
        aria-label={placeholder}
      />
      <StyledErrorWrapper $visible={!!showError}>
        <StyledErrorInner $visible={!!showError}>
          {error || '\u00A0'}
        </StyledErrorInner>
      </StyledErrorWrapper>
    </StyledWrapper>
  );
}
